import {
  municipalityMessages,
  whereToGetPermit,
  postMunicipalityMessage,
  getMunicipalitiesWithoutMessage,
  getOwnerInfo,
  getPermitContacts,
} from './services/settings-api';

export const SET_MUNICIPALITY_MESSAGES = 'settings/SET_MUNICIPALITY_MESSAGES';
export const SET_WHERE_TO_GET_PERMIT = 'settings/SET_WHERE_TO_GET_PERMIT';
export const FETCH_MUNICIPALITY_MESSAGES = 'settings/FETCH_MUNICIPALITY_MESSAGES';
export const FETCH_WHERE_TO_GET_PERMIT = 'settings/FETCH_WHERE_TO_GET_PERMIT';
export const POST_MUNICIPALITY_MESSAGE = 'settings/POST_MUNICIPALITY_MESSAGE';
export const SET_MUNI_WITHOUT_MESSAGE = 'settings/SET_MUNI_WITHOUT_MESSAGE';
export const FETCH_MUNI_WITHOUT_MESSAGE = 'settings/FETCH_MUNI_WITHOUT_MESSAGE';
export const SET_SITE_OWNERS = 'sites/SET_SITE_OWNERS';
export const FETCH_SITE_OWNERS = 'sites/FETCH_SITE_OWNERS';
export const FETCH_PERMIT_CONTACTS = 'sites/FETCH_PERMIT_CONTACTS';
export const SET_PERMIT_CONTACTS = 'sites/SET_PERMIT_CONTACTS';

export const settingsStore = {
  state: {
    muniMessages: null,
    muniMessage: null,
    municipalityWithoutMessage: null,
    owners: null,
    permitContacts: null,
  },
  mutations: {
    [SET_MUNICIPALITY_MESSAGES](state, { muniMessages }) {
      state.muniMessages = muniMessages;
    },
    [SET_WHERE_TO_GET_PERMIT](state, muniMessage) {
      state.muniMessage = muniMessage;
    },
    [SET_MUNI_WITHOUT_MESSAGE](state, { municipalityWithoutMessage }) {
      state.municipalityWithoutMessage = municipalityWithoutMessage;
    },
    [SET_SITE_OWNERS](state, { owners }) {
      if (owners !== null) {
        owners.forEach((owner) => {
        // eslint-disable-next-line no-return-assign, no-param-reassign
          owner.ownerFullInfo = `${owner.ownerID}, ${owner.fName} ${owner.lName}(${owner.ownerContactID}), ${owner.emailAddress}, (${owner.eServicesUserStatus})`;
        });
      }
      state.owners = owners;
    },
    [SET_PERMIT_CONTACTS](state, { permitContacts }) {
      if (permitContacts !== null) {
        permitContacts.forEach((owner) => {
        // eslint-disable-next-line no-return-assign, no-param-reassign
          owner.ownerFullInfo = `${owner.ownerID}, ${owner.fName} ${owner.lName}(${owner.ownerContactID}), ${owner.emailAddress}, (${owner.eServicesUserStatus} ${owner.isSiteOwner ? 'Owner' : 'Applicant'})`;
        });
      }
      state.permitContacts = permitContacts;
    },
  },
  getters: {
    getMunicipalityMessages: (state) => state.muniMessages,
    getWhereToGetPermit: (state) => state.muniMessage,
    getMunicipalityWithoutMessage: (state) => state.municipalityWithoutMessage,
    owners: (state) => state.owners,
    permitContacts: (state) => state.permitContacts,
  },
  actions: {
    [FETCH_WHERE_TO_GET_PERMIT]: async ({ commit }, payload) => {
      try {
        const muniCode = payload;
        const resp = await whereToGetPermit(muniCode);
        commit(SET_WHERE_TO_GET_PERMIT, resp.data);
      } catch (error) {
        commit(SET_WHERE_TO_GET_PERMIT, null);
        throw error;
      }
    },
    [FETCH_MUNICIPALITY_MESSAGES]: async ({ commit }) => {
      try {
        const resp = await municipalityMessages();
        const { data } = resp;
        commit(SET_MUNICIPALITY_MESSAGES, { muniMessages: data });
      } catch (error) {
        commit(SET_MUNICIPALITY_MESSAGES, { muniMessages: null });
        throw error;
      }
    },
    [POST_MUNICIPALITY_MESSAGE]: async (_, payload) => {
      try {
        const { data } = payload;
        await postMunicipalityMessage(data);
      } catch (error) {
        console.error(`post-municipality-message_err:${error.Status}`);
        throw error;
      }
    },
    [FETCH_MUNI_WITHOUT_MESSAGE]: async ({ commit }) => {
      try {
        const resp = await getMunicipalitiesWithoutMessage();
        const { data } = resp;
        commit(SET_MUNI_WITHOUT_MESSAGE, { municipalityWithoutMessage: data });
      } catch (error) {
        commit(SET_MUNI_WITHOUT_MESSAGE, { municipalityWithoutMessage: null });
        throw error;
      }
    },
    [FETCH_SITE_OWNERS]: async ({ state, commit }) => {
      try {
        if (state.owners) {
          return state.owners;
        }
        const resp = await getOwnerInfo();
        const { data } = resp;
        commit(SET_SITE_OWNERS, { owners: data });
      } catch (error) {
        commit(SET_SITE_OWNERS, { owners: null });
        throw error;
      }
    },
    [FETCH_PERMIT_CONTACTS]: async ({ state, commit }) => {
      try {
        if (state.permitContacts) {
          return state.permitContacts;
        }
        const resp = await getPermitContacts();
        const { data } = resp;
        commit(SET_PERMIT_CONTACTS, { permitContacts: data });
      } catch (error) {
        commit(SET_PERMIT_CONTACTS, { permitContacts: null });
        throw error;
      }
    },
  },
};
